import React from 'react'
import { FlexStyle } from './styles'

const Flex = ({ children, ...rest }) => {
  return <FlexStyle {...rest}>{children}</FlexStyle>
}

export default Flex
